import { Box, Button, Input } from '@mui/material';
import { useState } from 'react';

type Props = {
  label: string;
  name: string;
  accept?: string;
  variant?: 'text' | 'outlined' | 'contained';
  onChange: React.ChangeEventHandler<HTMLInputElement>;
};

function FileUploadInputButton(props: Props) {
  const [fileName, setFileName] = useState('');
  const onUploadFile: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    if (event.target.files && event.target.files.length > 0) {
      setFileName(event.target.files[0].name);
    }
    props.onChange(event);
  };

  return (
    <Box>
      <Button component="label" variant={props.variant}>
        {props.label}
        <Input
          type="file"
          sx={{ display: 'none' }}
          name={props.name}
          inputProps={{ accept: props.accept }}
          onChange={onUploadFile}
        />
      </Button>
      {fileName}
    </Box>
  );
}

export default FileUploadInputButton;
